import React, { Component } from 'react';

//componentes
import NotaCreditoM from './notaCreditoM'

class Index extends Component {

    render(){
        return(
            <div>
                <NotaCreditoM />
            </div>
        );
    }

}
export default Index;